// -----------------------------------------------------------------------------
// src/pages/Misc/bookingdialog.js
// -----------------------------------------------------------------------------
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BookingForm from '../../Components/BookingForm';

/**
 * BookingDialog
 *
 * PROPS
 *  - open          : boolean
 *  - onClose       : function
 *  - creator       : creator object
 *  - isCelebrity   : boolean  ← NEW (supplied by MediaKit)
 *
 * The `isCelebrity` flag is forwarded to BookingForm so it can decide whether
 * to pre-fill the “price” field (non-celebs) or leave it empty (celebs).
 */
const BookingDialog = ({ open, onClose, creator, isCelebrity = false }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Let's Chat!
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <BookingForm
          creator={creator}
          isCelebrity={isCelebrity}   // ← forward to the form
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BookingDialog;
